import AjaxGetProducts from "../modules/AjaxGetProducts";
import wishlist from '../modules/WishList';

export default {
  init() {

    new AjaxGetProducts({
      ajaxUrl: palram.ajax_url,
      action: 'palram_get_products',
      type: 'wishlist',
      secure: palram.nonces.get_products,
      wrapper: document.querySelector('.products'),
      loadMore: document.querySelector('#product-load-more'),
    });

    const shareMenu = document.querySelector('#wishlist_share');

    if(shareMenu) {
      const updateShareLink = () => {
        let ids = wishlist.getIds();

        ids = ids.slice(0, 10);

        if(ids.length === 0) {
          shareMenu.style.display = 'none';
          return;
        }

        const str = ids.join('.');
        const shareButtons = shareMenu.querySelectorAll('.dropdown-item');

        if(shareButtons && shareButtons.length > 0) {
          shareButtons.forEach(button => {
            const url = new URL(button.dataset.url);

            url.searchParams.set('products', str)
            button.dataset.url = `${url.origin}${url.pathname}?${decodeURIComponent(url.searchParams.toString())}`;
          });
        }
      }

      updateShareLink();

      document.body.addEventListener('wishlist_updated', updateShareLink)
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
